import { z } from "zod";
import { TeamRoles } from "./team-roles.ts";

export const CreateInviteDto = z.object({
  email: z.string(),
  role: z.enum(TeamRoles),
});

export const UpdateInviteDto = z.object({
  role: z.enum(TeamRoles),
});

export const AcceptInviteDto = z.object({
  externalId: z.string(),
});

export const InviteDto = z.object({
  externalId: z.string(),
  email: z.string(),
  role: z.enum(TeamRoles),
  createdAt: z.string().nullable(),
  updatedAt: z.string().nullable(),
  acceptedAt: z.string().nullable(),
  deletedAt: z.string().nullable(),
});

export const InviteStatusDto = z.object({
  name: z.string().nullable(),
  externalId: z.string().optional(),
  isEmailMismatch: z.boolean().optional(),
});

export type CreateInviteDto = z.infer<typeof CreateInviteDto>;
export type InviteDto = z.infer<typeof InviteDto>;
export type AcceptInviteDto = z.infer<typeof AcceptInviteDto>;
export type UpdateInviteDto = z.infer<typeof UpdateInviteDto>;
export type InviteStatusDto = z.infer<typeof InviteStatusDto>;
